import { abyssColors } from '@/theme/colors';

export const paperStyles = {
  maxWidth: '52.8rem',
};

export const titleStyles = {
  padding: '2.4rem',
  paddingBottom: '1rem',
  typography: 'h4',
};

export const actionsStyles = {
  borderTop: `0.1rem solid ${abyssColors.primary[100]}`,
  padding: '1.6rem 2.4rem 2rem 1.6rem',
  gap: '1.6rem',
  button: {
    margin: '0 !important',
  },
};

export const contentStyles = {
  padding: '2.4rem',
  paddingTop: '0',
};
